export default __webpack_public_path__ + "static/media/logo-geolocaux.425cc72e.svg";